@if (displayAmenities) {
  <h4 i18n="@@modalRoutehappyAmenities">Amenities</h4>
  @if (results.data?.amenitySummary[0].seat) {
    <div class="flight-amenity">
      <h5>
        <i class="ico-plain-seat" aria-hidden="true"></i>
        <span i18n="@@modalRoutehappyAmenitiesSeat">Seat</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].seat.displayText }}
      </div>
    </div>
  }
  @if (results.data?.amenitySummary[0].wifi) {
    <div class="flight-amenity">
      <h5>
        <fa-icon aria-hidden="true" [icon]="faWifi"> </fa-icon>
        <span i18n="@@modalRoutehappyAmenitiesWifi">Wi-Fi</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].wifi.displayText }}
      </div>
    </div>
  }
  @if (results.data?.amenitySummary[0].power) {
    <div class="flight-amenity">
      <h5>
        <fa-icon aria-hidden="true" [icon]="faPlug"> </fa-icon>
        <span i18n="@@modalRoutehappyAmenitiesPower">Power</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].power.displayText }}
        {{
          results?.data?.amenity?.powers[0].type
            ? '- Type: ' + results?.data.amenity?.powers[0].type
            : ''
        }}
      </div>
    </div>
  }
  @if (results.data?.amenitySummary[0].entertainment) {
    <div class="flight-amenity">
      <h5>
        <fa-icon aria-hidden="true" [icon]="faPlayCircle"> </fa-icon>
        <span i18n="@@modalRoutehappyAmenitiesEntertainment">Entertainment</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].entertainment.displayText }}
      </div>
    </div>
  }
  @if (results.data?.amenitySummary[0].freshFood) {
    <div class="flight-amenity">
      <h5>
        <fa-icon aria-hidden="true" [icon]="faUtensils"> </fa-icon>
        <span i18n="@@modalRoutehappyAmenitiesFood">Food</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].freshFood.displayText }}
      </div>
    </div>
  }
  @if (results.data?.amenitySummary[0].beverage) {
    <div class="flight-amenity">
      <h5>
        <fa-icon aria-hidden="true" [icon]="faGlassWhiskey"> </fa-icon>
        <span i18n="@@modalRoutehappyAmenitiesBeverage">Beverage</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].beverage.displayText }}
      </div>
    </div>
  }
  @if (results.data?.amenitySummary[0].aircraft) {
    <div class="flight-amenity">
      <h5>
        <fa-icon aria-hidden="true" [icon]="faPlane"> </fa-icon>
        <span i18n="@@modalRoutehappyAmenitiesAircraftLayout">Aircraft Layout</span>
      </h5>
      <div class="amenity-details">
        <span>&nbsp;-&nbsp;</span>{{ results?.data?.amenitySummary[0].aircraft.displayText }},
        {{ results?.data?.amenitySummary[0].layout.displayText }}
      </div>
    </div>
  }
}
@if (displayTicketFeatures) {
  <div class="ticket-features">
    <h4 i18n="@@modalRoutehappyAmenitiesTicketFeatures">Ticket Features</h4>
    @if (results?.data.checkedBag.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesCheckedBaggage">Checked Baggage</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.checkedBag[0].description }}
        </div>
      </div>
    }
    @if (results?.data.carryOnBag.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesCarryonBaggage">Carry-on Baggage</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.carryOnBag[0].description }}
        </div>
      </div>
    }
    @if (results?.data.seatSelection.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@routehappyAmenitiesSeatSelection">Seat Selection</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.seatSelection[0].description }}
        </div>
      </div>
    }
    @if (results?.data.boardingPriority.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesBoardingPriority">Boarding Priority</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.boardingPriority[0].description }}
        </div>
      </div>
    }
    @if (
      results?.data.advanceChange.length &&
      (results?.data.advanceChange[0].anytime ||
        results?.data.advanceChange[0].beforeDeparture ||
        results?.data.advanceChange[0].afterDeparture)
    ) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesAdvanceChange">Advance Change</span>
        </h5>
        @if (results?.data.advanceChange[0].anytime) {
          <div class="amenity-details">
            {{ results?.data.advanceChange[0].anytime.description }}
            <span i18n="@@modalRoutehappyAmenitiesAnytime">(Anytime)</span>
          </div>
        }
        @if (results?.data.advanceChange[0].beforeDeparture) {
          <div class="amenity-details">
            {{ results?.data.advanceChange[0].beforeDeparture.description }}
            <span i18n="@@modalRoutehappyAmenitiesBeforeDeparture">(Before Departure)</span>
          </div>
        }
        @if (results?.data.advanceChange[0].afterDeparture) {
          <div class="amenity-details">
            {{ results?.data.advanceChange[0].afterDeparture.description }}
            <span i18n="@@modalRoutehappyAmenitiesAfterDeparture">(After Departure)</span>
          </div>
        }
      </div>
    }
    @if (
      results?.data.cancellation.length &&
      (results?.data.cancellation[0].anytime ||
        results?.data.cancellation[0].beforeDeparture ||
        results?.data.cancellation[0].afterDeparture)
    ) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesCancellation">Cancellation</span>
        </h5>
        @if (results?.data.cancellation[0].anytime) {
          <div class="amenity-details">
            {{ results?.data.cancellation[0].anytime.description }}
            <span i18n="@@modalRoutehappyAmenitiesAnytime">(Anytime)</span>
          </div>
        }
        @if (results?.data.cancellation[0].beforeDeparture) {
          <div class="amenity-details">
            {{ results?.data.cancellation[0].beforeDeparture.description }}
            <span i18n="@@modalRoutehappyAmenitiesBeforeDeparture">(Before Departure)</span>
          </div>
        }
        @if (results?.data.cancellation[0].afterDeparture) {
          <div class="amenity-details">
            {{ results?.data.cancellation[0].afterDeparture.description }}
            <span i18n="@@modalRoutehappyAmenitiesAfterDeparture">(After Departure)</span>
          </div>
        }
      </div>
    }
    @if (results?.data.sameDayChange.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesSameDayChange">Same Day Change</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.sameDayChange[0].description }}
        </div>
      </div>
    }
    @if (results?.data.checkInPriority.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesCheckinPriority">Check-in Priority</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.checkInPriority[0].description }}
        </div>
      </div>
    }
    @if (results?.data.loungeAccess.length) {
      <div class="flight-amenity">
        <h5>
          <span i18n="@@modalRoutehappyAmenitiesLoungeAccess">Lounge Access</span>
        </h5>
        <div class="amenity-details">
          {{ results?.data.loungeAccess[0].description }}
        </div>
      </div>
    }
  </div>
}
@if (!displayAmenities && !displayTicketFeatures) {
  <div class="error-message" i18n="@@modalRoutehappyAmenitiesUnavailable">
    Amenities & Ticket Features unavailable for this flight.
  </div>
}
